import {Debtor} from '../../../types/Debtor/Debtor';
import {TFunction} from 'react-i18next';
import React, {ReactElement} from 'react';
import DebtorNewPaymentAction from './DebtorNewPaymentAction';
import DebtorShowPaymentsAction from './DebtorShowPaymentsAction';
import DebtorEditAction from './DebtorEditAction';
import DebtorDeleteAction from './DebtorDeleteAction';
import DebtorChangePaymentMethodAction from './DebtorChangePaymentMethodAction';
import DebtorResendInvitationAction from './DebtorResendInvitationAction';
import DebtorNewInvoiceAction from './DebtorNewInvoiceAction';
import DebtorNewInstalmentPlanAction from './DebtorNewInstalmentPlanAction';
import DebtorEditAdditionalEmailsAction from './DebtorEditAdditionalEmailsAction';

const getActionsForDebtor = (debtor: Debtor, setMenuAnchor: (x: any) => void, t: TFunction, mode?: 'detailsPage') => {
  const actions: ReactElement[] = [];
  actions.push(<DebtorNewPaymentAction key="new-payment" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('new payment')} />);
  actions.push(<DebtorNewInvoiceAction key="new-invoice" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('new invoice')} />);
  actions.push(<DebtorNewInstalmentPlanAction key="new-instalment-plan" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('new instalment plan')} />);
  if (mode !== 'detailsPage') {
    actions.push(<DebtorShowPaymentsAction key="show-payments" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('payments')} />);
  }
  actions.push(<DebtorEditAction key="edit" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('edit')} />);
  actions.push(<DebtorEditAdditionalEmailsAction key="edit-emails" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('edit invoice emails')} />);
  actions.push(<DebtorDeleteAction key="delete" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('delete')} />);
  actions.push(<DebtorChangePaymentMethodAction key="change-payment-method" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('change payment method')} />);
  actions.push(<DebtorResendInvitationAction key="resend-invitation" debtor={debtor} setMenuAnchor={setMenuAnchor} label={t('resend invitation')} />);

  return actions;
};

export type DebtorActionType = {
  debtor: Debtor;
  setMenuAnchor: (x: any) => void;
  label: string;
};

export { getActionsForDebtor };
